<template>
  <div
      v-if="log"
      :class="[`${bemClassName}__row`, `${bemClassName}__row-detail`, { [`${bemClassName}__highlight`]: isSelected }]"
      role="row">
    <div
        v-for="detail in detailItems"
        :key="detail.detailKey"
        :class="[`${bemClassName}__cell`, `${bemClassName}__${detail.detailKey}`]"
        role="gridcell">
      <span
          v-html="detail.detail"
          :class="`${bemClassName}__cell-detail`">
        {{detail.detail}}}
      </span>
      <small v-if="detail.isScheduled" :class="[`${bemClassName}__scheduled`]">scheduled</small>
      <small v-if="detail.isPending" :class="[`${bemClassName}__pending`]">pending</small>
    </div>
  </div>
</template>

<script>
  import LogDateFormat from '../mixins/LogDateFormat'
  import { NumberFormatters } from '../mixins/NumberFormatters.js'

  export default {
    props: {
      bemClassName: {
        default: 'log-details',
        type: String
      },
      detailKeys: Array,
      isSelected: Boolean,
      log: Object,
    },

    name: 'PerformanceLogDetailRow',

    mixins: [LogDateFormat, NumberFormatters],

    data() {
      return {
        keysNeedDateFormat: ['sent_time'],
        keysNeedNumberFormat: ['sms_sent']
      }
    },

    computed: {
      detailItems: function () {
        if (!this.log) { return }
        let details = []
        this.detailKeys?.forEach((key) => {
          let detail = this.log[key],
            detailItem = { detailKey: key, detail }
          if (this.keysNeedDateFormat.includes(key)) { this.buildDateDetail(detailItem) }
          if (this.keysNeedNumberFormat.includes(key)) { this.buildNumberDetail(detail, detailItem) }
          if (key === 'final_sms_content') { detailItem.detail = this.replaceNewLinesWithBr(detail) }
          return details.push(detailItem)
        })
        return details
      },

      isScheduled: function () {
        return !this.sentDate && !!this.scheduledDate
      },

      scheduledDate: function () {
        return this.log?.scheduled_for
      },

      sentDate: function () {
        return this.log?.sent_time
      }
    },

    methods: {
      buildDateDetail(detailItem) {
        const detail = this.sentDate || this.scheduledDate
        detailItem.detail = this.formatLogDate(detail)
        detailItem.isScheduled = this.isScheduled
        return detailItem
      },

      buildNumberDetail(detail, detailItem) {
        detailItem.detail = detail ? this.shortenNumber(detail) : ''
        detailItem.isPending = this.isScheduled
        return detailItem
      },

      replaceNewLinesWithBr(str) {
        if (!str) { return '' }
        return str.replace(/(\\r)*\\n/g, '<br>')
      }
    },
  }
</script>
